import Layout from "./Layout";
import IndexPage from "./IndexPage";
import { Toolboxes } from "./Toolboxes";

const Index = IndexPage;

export const Admin = {
  Layout,
  Index,
  Toolboxes,
};
